import { useEffect, useState } from 'react'
import apiGet from 'lib/network/apiGet'
import Button from 'components/atoms/Button'
import Selection from 'components/molecules/Selection'
import apiPut from 'lib/network/apiPut'

const LeadAssignModal = ({ leadId, onSuccess, t, close }) => {
  const [users, setUsers] = useState([])
  const [filteredUsers, setFilteredUsers] = useState([])
  const [assignedUser, setAssignedUser] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const load = async () => {
      const usersRes = await apiGet('crm/leads/assignable-users')
      const mappedUsers = (usersRes?.data || []).map(item => ({ id: item._id, name: item.fullName || item.email || item.phone }))
      setUsers(mappedUsers)
      setFilteredUsers(mappedUsers)
    }
    load()
  }, [])

  const handleUserSearch = query => {
    // eslint-disable-next-line
    const normalizedQuery = query?.trim()?.toLowerCase() || ''
    if (!normalizedQuery) {
      setFilteredUsers(users)
      return
    }
    // eslint-disable-next-line
    setFilteredUsers(users.filter(user => (user?.name || '').toLowerCase().includes(normalizedQuery)))
  }

  const submit = async () => {
    if (!assignedUser?.id) return
    setLoading(true)
    const res = await apiPut(`crm/leads/${leadId}/assign`, {
      assignedUser: assignedUser.id,
    })
    setLoading(false)
    if (res?.success) {
      onSuccess?.()
      close?.()
    }
  }

  return (
    <div className="h-full flex flex-col">
      <Selection
        className="min-h-[36px]"
        title={t('crm.labels.assignedUser')}
        list={filteredUsers}
        value={assignedUser?.id || ''}
        onChange={setAssignedUser}
        showSearch
        onSearch={handleUserSearch}
      />
      <div className="mt-auto pt-1 flex justify-end">
        <Button size="sm" className="h-8 px-3" onClick={submit} disabled={loading}>
          {loading ? t('crm.actions.assigning') : t('crm.actions.assign')}
        </Button>
        <button
          type="button"
          className="ml-2 inline-flex justify-center rounded-md border border-transparent bg-gray-100 px-4 py-2 text-sm font-medium text-gray-900 hover:bg-gray-200 focus:outline-none"
          onClick={() => close?.()}
          disabled={loading}
        >
          {t('common.cancel')}
        </button>
      </div>
    </div>
  )
}

export default LeadAssignModal
